export default "__VITE_ASSET__DeFxmmQO__"